import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { isEqual, cloneDeep } from 'lodash';
import ContentTile from 'components/atoms/layout/ContentTile';
import ContentHeader from 'components/atoms/layout/ContentHeader';
import helpers from 'helpers';
import apacMapData from 'helpers/highmaps/geo/apac';
import { AbstractChart } from 'containers/charts/AbstractChart';


apacMapData.features = apacMapData.features.filter((e) => {
    if (['Western Asia'].includes(e.properties.subregion)) {
        return false;
    }

    if (['Afghanistan', 'Pakistan'].includes(e.properties.name)) {
        return false;
    }

    return !['Middle East & North Africa', 'Europe & Central Asia'].includes(e.properties['region-wb']);
});
class GeoBreakdownMap extends Component {
    shouldComponentUpdate(nextProps) {
        return !isEqual(nextProps.data, this.props.data);
    }

    render() {
        const { title, changeCountry, data } = this.props;
        return (
            <ContentTile padding={helpers.contentPadding('geo-lab')}>
                <ContentHeader hideCSVExport={true} type={'geo-lab'}>{title}</ContentHeader>
                <AbstractChart config={{
                    chart: {
                        backgroundColor: '#E1F1F9',
                        margin: 0,
                        height: 724,
                        type: 'map'
                    },

                    title: {
                        text: null
                    },

                    credits: {
                        enabled: false
                    },

                    legend: {
                        enabled: false
                    },

                    mapNavigation: {
                        enabled: true,
                        buttonOptions: {
                            verticalAlign: 'bottom'
                        }
                    },

                    colorAxis: {
                        min: 0
                    },
                    plotOptions: {
                        series: {
                            events: {
                                click(e) {
                                    changeCountry(e.point.name);
                                }
                            }
                        },
                        map: {
                            allowPointSelect: true
                        }
                    },
                    exporting: {
                        enabled: false
                    },

                    series: [{
                        data: cloneDeep(data),
                        mapData: apacMapData,
                        name: 'Country',
                        borderColor: 'black',
                        borderWidth: 0.2,
                        states: {
                            hover: {
                                borderWidth: 1,
                                color: '#FFDB00'
                            },
                            select: {
                                color: '#FFDB00'
                            }
                        },
                        dataLabels: {
                            enabled: true,
                            format: '{point.name}'
                        }
                    }]
                }} />
            </ContentTile>
        );
    }
}

GeoBreakdownMap.propTypes = {
    data: PropTypes.array.isRequired,
    title: PropTypes.string.isRequired,
};

export default GeoBreakdownMap;



// WEBPACK FOOTER //
// ./src/components/molecules/charts/labs/GeoBreakdownMap.js